<script>
  import { t } from '../i18n/index.js';

  // The one loading indicator every screen uses. A bare spinning <div> is
  // invisible to a screen reader — it has no text and no role — so a blind
  // user is told nothing at all while the page waits. The live region says
  // "Caricamento…" out loud instead.
  export let label = '';
  /** Vertical padding of the wrapper; pass '' to drop it. */
  export let padding = 'py-12';

  $: text = label || $t('app.loading');
</script>

<div class="flex justify-center {padding}" role="status" aria-live="polite">
  <div class="loading-spinner rounded-full h-10 w-10"></div>
  <span class="sr-only">{text}</span>
</div>
